module.exports = __webpack_public_path__ + "static/logo-1beb72e814319c989b4a716e5d436f00.svg";